import React from 'react';

const testimonials = [
  "One of the best AI workshops I've ever done. I love how simple the AI tools were. Our instructor Robbie was very kind and knowledgeable. If I had trouble with something, he made it easy for me to understand.",
  "You guys thought of it all! Thank you for being so organized, informative and kind!!",
  //   "I really liked what I did here and engineering and coding are my favorite things, so this was a blast!",
  "I had an amazing time and I want to do it again.",
  "This was the best workshop I've done—it was very fun and informative.",
  //   "I just think it's great.",
  "Really liked it, had lots of fun, and the staff was really nice.",
  //   "This was amazing and I don't know if it could really be improved.",
  "It was a really fun workshop, tested our engineering skills hands-on.",
  //   "I had a great time—thank you for the experience!",
  //   "It was an amazing experience!",
  //   "The most engaging and interesting part of my time at this camp so far.",
  //   "I had a lot of fun learning about neural networks and AI tools.",
  "Neural network game made a complicated concept easy to understand.",
  //   "I love the discussion at the end about AI now and the ethics behind it.",
  //   "I was intrigued and interested by the information presented by my instructor. I had a great time with this workshop.",
  //   "It was a great time to learn neural networks.",
  "I had a lot of fun! I really liked all parts. This really helped me get a better understanding of how AI works.",
  //   "I enjoyed the entire workshop; however, the one thing I would include would be more on ethics and a section on AI development careers and job opportunities.",
  //   "Loved it! Thank you so much for this experience."
];

const to_be_or_not_to_be = [
  "To be, or not to be, that is the question:",<br/>,
  "Whether 'tis nobler in the mind to suffer",<br/>,
  "The slings and arrows of outrageous fortune,",<br/>,
  "Or to take arms against a sea of troubles",<br/>,
  "And by opposing end them. To die—to sleep,",<br/>,
  // "No more; and by a sleep to say we end",<br/>,
  // "The heart-ache and the thousand natural shocks",<br/>,
  // "That flesh is heir to: 'tis a consummation",<br/>,
  // "Devoutly to be wish'd. To die, to sleep;",<br/>,
  // "To sleep, perchance to dream—ay, there's the rub:",<br/>,
  // "For in that sleep of death what dreams may come,",<br/>,
  // "When we have shuffled off this mortal coil,",<br/>,
  // "Must give us pause—there's the respect",<br/>,
  // "That makes calamity of so long life.",<br/>,
  // "For who would bear the whips and scorns of time,",<br/>,
  // "Th'oppressor's wrong, the proud man's contumely,",<br/>,
  // "The pangs of dispriz'd love, the law's delay,",<br/>,
  // "The insolence of office, and the spurns",<br/>,
  // "That patient merit of th'unworthy takes,",<br/>,
  // "When he himself might his quietus make",<br/>,
  // "With a bare bodkin? Who would fardels bear,",<br/>,
  // "To grunt and sweat under a weary life,",<br/>,
  // "But that the dread of something after death,",<br/>,
  // "The undiscovere'd country, from whose bourn",<br/>,
  // "No traveller returns, puzzles the will,",<br/>,
  // "And makes us rather bear those ills we have",<br/>,
  "Than fly to others that we know not of?",<br/>,
  "Thus conscience doth make cowards of us all,",<br/>,
  "And thus the native hue of resolution",<br/>,
  "Is sicklied o'er with the pale cast of thought,",<br/>,
  "And enterprises of great pith and moment",<br/>,
  "With this regard their currents turn awry",<br/>,
  "And lose the name of action.",<br/>,
];
const Testimonials = (props) => {
  // If there is no voice over prompt from the user, we will show a default quote from a movie.


  let voiceOver = props.voiceOver;
  if (!voiceOver || voiceOver === "") {
    voiceOver = to_be_or_not_to_be;
  }

  return (
    <>
      <div>
        <ul>
          <li>Step 1: Please speak naturally and clearly.</li>
          <li>Step 2: Read the following text aloud in its entirety.</li>
          <li>Step 3: Once you've finished, select the stop and clone voice button</li>
        </ul>
      </div>
      {/* <div className="testimonials-block">
      {testimonials.map((quote, index) => (
        <div key={index} className="testimonial-line">
          "{quote}"
        </div>
      ))}
    </div> */}
      <div className="testimonials-block">
        {voiceOver}
      </div>
    </>
  );
};


export { Testimonials };
